/* @flow */

import * as React from 'react';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroCheckbox from 'forms/components/inputs/ElectroCheckbox/ElectroCheckbox';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ElectroSelect from 'forms/components/inputs/ElectroSelect/ElectroSelect';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import type { TypeDisplayErrors } from 'forms/validation/Validator';
import styles from 'views/ActionDrawer/ActionDrawer.module.scss';
import type Form from 'forms/_.extend';

import { autoCompleteCountries } from 'api/forms.js';

const assetCalc: Function = (form: Object, field: boolean) => {
  const rec = field ? 'required' : '';
  form.set('rules', {
    addSystemForm: {
      assetType: rec,
      assetDescription: rec,
      assetNumber: rec,
      assetBarcodeNumber: rec,
      assetSerialNumber: rec,
    },
  });
};

type TypeProps = {
  project: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AddNewSystemForm extends React.Component<*> {
  @computed get form(): Object {
    return this.props.form;
  }

  componentDidUpdate() {
    assetCalc(this.form, this.form.$('addSystemForm.assetizedLocation').value);
  }

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;

    const assetizedLocation = (
      <div className={styles['form-group']}>
        <ElectroSelect field={this.form.$('addSystemForm.assetType')} simpleValue={true} />
        <ElectroTextField field={this.form.$('addSystemForm.assetDescription')} />
        <ElectroTextField field={this.form.$('addSystemForm.assetNumber')} />
        <ElectroTextField field={this.form.$('addSystemForm.assetBarcodeNumber')} />
        <ElectroTextField field={this.form.$('addSystemForm.assetSerialNumber')} />
      </div>
    );

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock divider={false} gutters={true}>
            <div className={styles['form-group']}>
              <ElectroTextField field={this.form.$('addSystemForm.systemName')} />
              <ElectroTextField field={this.form.$('addSystemForm.contactPhoneNo')} />
              <ElectroTextField field={this.form.$('addSystemForm.contactFaxNo')} />
              <ElectroTextField field={this.form.$('addSystemForm.locationContact')} />
            </div>
            <React.Fragment>
              <ElectroCheckbox field={this.form.$('addSystemForm.assetizedLocation')} />
            </React.Fragment>
            {this.form.$('addSystemForm.assetizedLocation').value ? assetizedLocation : null}
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={this.form} submitTxt={t('general:actions.create')} />
      </React.Fragment>
    );
  }
}
